function UnAthorised() {
    return (
        <div>
            <div style={{ margin: "20%", textAlign: "center", fontSize: "16pt" }}>
                You do not have access to the system.<br></br>Please contact support
            </div>
        </div>
    );
}
export default UnAthorised;
